export const COMPONENT_NAME = "shared-info-notice";
